import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FiInfo, FiX } from 'react-icons/fi';

const SectionHelpModal = ({ title, content, style }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <button
                onClick={handleShow}
                style={{
                    background: 'none',
                    border: 'none',
                    color: 'var(--text-secondary, #64748b)',
                    padding: '0 8px',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'color 0.3s ease, transform 0.2s',
                    ...style
                }}
                title="¿Cómo funciona esta sección?"
                onMouseEnter={(e) => {
                    e.currentTarget.style.color = 'var(--primary-color, #6366f1)';
                    e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={(e) => {
                    e.currentTarget.style.color = 'var(--text-secondary, #64748b)';
                    e.currentTarget.style.transform = 'scale(1)';
                }}
            >
                <FiInfo size={22} />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                backdrop="static"
                keyboard={true}
                animation={true}
            >
                <Modal.Header style={{ borderBottom: '1px solid var(--border-color, #e2e8f0)', padding: '1.25rem 1.5rem', background: 'var(--bg-color, #f8fafc)' }}>
                    <Modal.Title style={{ fontSize: '1.25rem', fontWeight: '600', color: 'var(--text-primary, #1e293b)', display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <FiInfo color="var(--primary-color, #6366f1)" size={24} />
                        {title}
                    </Modal.Title>
                    <button
                        onClick={handleClose}
                        style={{ background: 'none', border: 'none', color: 'var(--text-secondary, #64748b)', cursor: 'pointer', transition: 'color 0.2s' }}
                        onMouseEnter={(e) => e.currentTarget.style.color = 'var(--danger-red, #ef4444)'}
                        onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary, #64748b)'}
                    >
                        <FiX size={24} />
                    </button>
                </Modal.Header>
                <Modal.Body style={{ padding: '1.5rem', color: 'var(--text-primary, #1e293b)', fontSize: '0.95rem', lineHeight: '1.6' }}>
                    {content}
                </Modal.Body>
                <Modal.Footer style={{ borderTop: 'none', padding: '1rem 1.5rem', justifyContent: 'center' }}>
                    <Button variant="primary" onClick={handleClose} style={{ background: 'var(--primary-color, #6366f1)', border: 'none', padding: '0.6rem 2rem', borderRadius: '8px', fontWeight: '500', transition: 'transform 0.2s' }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                        ¡Entendido!
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SectionHelpModal;
